import usflag from "./usflag.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-info-container">
        <span>Lifetime Products, Inc.</span>
        <p>PO Box 160010, Freeport Center, Building D-11</p>
        <p>Clearfield, Utah 84016-0010 USA</p>
        <p>+1-800-225-3865</p>
        <p>(CC) {new Date().getFullYear()}, except where noted otherwise.</p>
      </div>
      <div className="flag-image-container">
        <a title="PROUD U.S.A. MANUFACTURER" href="/">
          <img title="PROUD U.S.A. MANUFACTURER" alt="PROUD U.S.A. MANUFACTURER" className="footer-logo w-50 float-none float-md-end" src={usflag} />
        </a>
      </div>
    </div>
  );
};

export default Footer;
